import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { FETCH_USER } from '../actions/types';

const Logout = () => {
    const dispatch = useDispatch();

    const handleLogout = useCallback(() => {
        //this is set in Google Tag Manager
        localStorage.removeItem('fsUserIdSent');

        // Clear authentication state
        localStorage.removeItem('isAuthenticated');

        // Clear Redux store
        dispatch({ type: FETCH_USER, payload: null });
    }, [dispatch]);

    useEffect(() => {
        const performLogout = async () => {
            try {
                await axios.get(`/api/logout`, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                    timeout: 5000 // 5 second timeout
                });
            } catch (error) {
                console.error('Logout API call failed:', error);
                // Even if the API call fails, we should still clear local state
            }

            // Always clear local state and redirect, regardless of API call result
            handleLogout();

            // Use a small delay to ensure state is cleared before redirect
            setTimeout(() => {
                window.location.assign("/login");
            }, 100);
        };

        performLogout();
    }, [handleLogout]);

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <title>Logging Out - Spawnry</title>
            </Helmet>

            {/* Dark Header - Full Page */}
            <div style={{
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={6} className="text-center">
                            <div style={{
                                width: '64px',
                                height: '64px',
                                margin: '0 auto 1.5rem',
                                position: 'relative'
                            }}>
                                <div style={{
                                    width: '64px',
                                    height: '64px',
                                    border: '3px solid rgba(99, 102, 241, 0.3)',
                                    borderTopColor: '#6366f1',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite'
                                }} />
                                <style>{`
                                    @keyframes spin {
                                        to { transform: rotate(360deg); }
                                    }
                                `}</style>
                            </div>
                            <h1 style={{
                                color: 'white',
                                fontWeight: '600',
                                fontSize: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>
                                Logging out...
                            </h1>
                            <p style={{
                                color: 'rgba(255, 255, 255, 0.6)',
                                fontSize: '1rem',
                                margin: 0
                            }}>
                                Please wait while we sign you out
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default Logout;
